export default __webpack_public_path__ + "static/media/team-pic-temp1.16f44a8c.png";